import { isEqual } from 'lodash';
import { API } from '@shared/types/api';

export function isCollectionCriteriaEqual(
  saved: API.CollectionCriteriaFragment | null,
  updated: API.CollectionCriteriaFragment | null,
): boolean {
  const isFiltersEqual = isCriterionEqual(saved?.filterByComponents, updated?.filterByComponents);
  const isSortsEqual = isCriterionEqual(saved?.sortByComponents, updated?.sortByComponents);
  const isGroupsEqual = isCriterionEqual(saved?.groups, updated?.groups);

  return isFiltersEqual && isSortsEqual && isGroupsEqual;
}

type CollectionCriterion =
  | API.FilterByComponentObject[]
  | API.SortByComponent[]
  | API.CollectionGroupObject[];

function isCriterionEqual<T extends CollectionCriterion>(
  saved: T | null | undefined,
  updated: T | null | undefined,
): boolean {
  return isEqual(saved ?? [], updated ?? []);
}
